import React, { FC } from 'react';

import { useLang } from 'hooks';
import { DashboardLayout } from 'layouts';
import { Grid } from 'components/ui';
import { Balance as TBalance, Withdrawal } from 'types/models';

import Balance from './Balance';
import Payouts from './Payouts';
import Settings from './Settings';

type WithdrawalViewProps = {
  balance: TBalance;
  withdrawal: Withdrawal;
};

const WithdrawalView: FC<WithdrawalViewProps> = ({ balance, withdrawal }) => {
  const lang = useLang();

  return (
    <DashboardLayout title={lang.get('withdrawal.title')}>
      <Grid.Row>
        <Grid.Col>
          <Balance balance={balance} />
        </Grid.Col>
        <Grid.Col md={12}>
          <Settings withdrawal={withdrawal} />
        </Grid.Col>
        <Grid.Col>
          <Payouts />
        </Grid.Col>
      </Grid.Row>
    </DashboardLayout>
  );
};

export default WithdrawalView;
